import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { formatUsd } from "./paymentFeature";

const SuccessfulPaymentDialog = ({
  amountCents = 0,
  badgeCreditPurchasedCount = 0,
  badgeCreditUsedCount = 0,
  canGenerate = true,
  onClose,
  onContinue,
  open,
}) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [generationError, setGenerationError] = useState("");

  useEffect(() => {
    if (!open) {
      setIsGenerating(false);
      setGenerationError("");
    }
  }, [open]);

  const handleContinue = async () => {
    setIsGenerating(true);
    setGenerationError("");
    try {
      await onContinue();
    } catch (error) {
      setGenerationError(error.message || "Could not generate badges.");
      setIsGenerating(false);
    }
  };

  return (
    <Dialog open={open} disableEnforceFocus>
      <DialogContent className="payment-success-content">
        <CheckCircleIcon className="payment-success-icon" />
        <div>
          <h3 className="dialog-title">Successful payment</h3>
          <div>
            {amountCents > 0 && badgeCreditPurchasedCount > 0
              ? `${formatUsd(amountCents)} was received. ${badgeCreditPurchasedCount} prepaid badge credit${badgeCreditPurchasedCount === 1 ? " was" : "s were"} added for future use. Your badges are ready to generate.`
              : amountCents > 0
              ? `${formatUsd(amountCents)} was received. Your badges are ready to generate.`
              : badgeCreditUsedCount > 0
              ? `${badgeCreditUsedCount} prepaid badge credit${badgeCreditUsedCount === 1 ? "" : "s"} covered this set. Your badges are ready to generate.`
              : "Your existing purchase and typo allowance cover this set. Your badges are ready to generate."}
          </div>
        </div>
      </DialogContent>
      {generationError && (
        <div className="payment-generation-error" role="alert">
          {generationError}
        </div>
      )}
      <DialogActions>
        <button
          className="button"
          disabled={isGenerating}
          onClick={onClose}
        >
          Close
        </button>
        <button
          className="primary"
          disabled={isGenerating || !canGenerate}
          onClick={handleContinue}
        >
          {isGenerating ? (
            <>
              <div className="spinner"></div>
              Generating badges...
            </>
          ) : (
            "Download badges"
          )}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessfulPaymentDialog;
